<template>
    <v-col v-if="tour">
        <div class="wrap-head-detail">
            <v-btn class="btn-back" elevation="0" text @click="$router.go(-1)">
                <v-icon size="18">mdi-arrow-left</v-icon>
                {{ $t("global.back") }}
            </v-btn>

            <div class="wrap-head-btn d-flex align-center">
                <h1>{{ $t("tours.tour") }} {{ tour.designation }}</h1>
                <span class="id-tour">#{{
                        String(tour.id).padStart(4, 0)
                    }}</span>
            </div>
            <div class="infos-tour">
                <span class="element">
                    {{ tour.site_code }}
                    , modèle n°
                    {{ tour.model_number_code }}</span>
                <span class="element">Type : {{ tour.label }}</span>
                <span class="element">Prise en charge par :
                    {{ tour.driver | preventNull }}
                </span>
                <span class="element"
                >Tournée : {{ getLastUpdate }}</span
                >
            </div>

            <v-btn v-if="userHasRole('ADMIN_PU') || userHasRole('ADMIN')" class="admin-button" depressed color="error" @click="openAdmin = true">
                <v-icon left>mdi-security</v-icon>
                Nettoyage
            </v-btn>
        </div>
        <div class="wrap-detail">
            <Load :tour="tour"/>
            <Deliveries :steps="tour.steps"/>

            <div class="wrap-accordions">
                <v-expansion-panels
                    v-model="expanded"
                    focusable
                    multiple
                >
                <delivery-step v-for="(step, index) in tour.steps"
                               :key="step.id"
                               :ref="`step_${step.id}`"
                               :date="tour.expected_date"
                               :step="step"
                               :active="isStepActive(index)"/>
                </v-expansion-panels>
            </div>
        </div>

        <Administration :visible="openAdmin" @close="openAdmin = false" @validate="cleanPackage"/>
    </v-col>
    <v-col v-else>
        {{ $t('global.loading') }}
    </v-col>
</template>

<script>
import Load from "@/components/tours/load";
import Deliveries from "@/components/tours/infos_deliveries";
import DeliveryStep from "@/components/tours/delivery_point";
import {TOUR_DELIVERED_STATE} from "../../constants";
import roles from "../../mixins/roles";
import Administration from "../../components/tours/administration.vue";
import { showSnackbar } from "../../functions";

export default {
    name: "DetailTour",
    components: {
        Administration,
        Load,
        Deliveries,
        DeliveryStep
    },
    mixins: [roles],
    data() {
        return {
            tour: null,
            expanded: [],
            openAdmin: false
        }
    },
    computed: {
        getLastUpdate() {
            if (!this.tour) {
                return
            }
            if (this.tour && this.tour.tour_state.code === TOUR_DELIVERED_STATE) {
                return this.$t('tours.tour_status_date',
                    [this.$t('tour_states.delivered'),
                        this.tour.end_datetime.toDateTime()])
            }
            return this.$t('tours.tour_status_date',
                [
                    this.$t(`tour_states.${this.tour.tour_state.code}`),
                    this.tour.updated_at.toDateTime()
                ]
            )
        }
    },
    async mounted() {
        const position = parseInt(this.$route.query.position)
        if (!isNaN(position)) {
            this.expanded.push(position)
        }
        this.tour = (await this.$api.tours.get(
                this.$route.params.id,
                {
                    params: {
                        includes:
                            'tour.steps,step.step_state,tour.loading_states,step.delayed_step,step.customer,tour.tour_model,tour_model.tour_type,tour.tour_state,step.anomaly,anomalisable.anomaly,tour.missing_loadings,tour.anomaly,step.products'
                    }
                }
            )
        ).data.data
    },
    methods: {
        isStepActive(index) {
            return (this.expanded || []).includes(index)
        },
        async cleanPackage(val, next = false) {
            let returnVal = (await this.$api.tours.cancelTour(this.$route.params.id, {
                reason: val,
                next: next
            }))

            showSnackbar('success', "Nettoyage effectué avec succès")
            this.openAdmin = false
        }
    },
};
</script>

<style scoped>
.wrap-head-detail {
    position: relative;
}

.wrap-head-detail .admin-button {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
}
</style>
